import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ResultColumnsService } from '../../services/result-columns.service';

@Component({
  selector: 'app-columns-select-panel',
  templateUrl: './columns-select-panel.component.html',
  styleUrls: ['./columns-select-panel.component.css']
})
export class ColumnsSelectPanelComponent implements OnInit {

  @Input() cols: any[] = [];
  @Input() selectedCols: any[] = [];

  @Output() columnsChangedEvent = new EventEmitter<any>();

  constructor(private columnsSvc: ResultColumnsService, private msgSvc: MessageService) {

  }

  ngOnInit(): void {
    this.columnsSvc.selectedCols$.subscribe(cols => {this.selectedCols = cols });
    // this.columnsSvc.parseSelectedCols(this.tableCols);
  }

  columnsChanged(event: any) {
    this.columnsChangedEvent.emit(this.selectedCols);
    this.msgSvc.add({ key: 'columnAdded', severity: 'success', summary: 'Columns have been updated, you might have to scroll right to view.' });
  }
}
